import React from 'react';

// The offer to do the setup for someone. Sits under the signup form so it is
// read after the form, never beside it competing with the fields.
export default function SetupHelp() {
  const linkClass = 'inline-flex min-h-[44px] items-center text-sm font-medium text-blue-700 underline underline-offset-4';
  return (
    <section aria-labelledby="setup-help-heading" className="border-t border-slate-200 pt-5">
      <h3 id="setup-help-heading" className="text-sm font-semibold text-slate-950">Want us to set it up for free?</h3>
      <p className="mt-1 text-sm leading-6 text-slate-600">We can set up your AI agent for free. You keep control of your account and content.</p>
      <a className={linkClass} href="https://serviti.ai/trial" target="_blank" rel="noopener noreferrer">Have Serviti set it up for free</a>
      <div className="flex flex-wrap gap-x-4">
        <a className={linkClass} href="mailto:sales@serviti.ai">Email us</a>
        <a className={linkClass} href="https://wa.me/918555811800" target="_blank" rel="noopener noreferrer">WhatsApp</a>
        <a className={linkClass} href="tel:+918555811800">+91 85558 11800</a>
      </div>
    </section>
  );
}
